import { __rest, __assign } from 'tslib';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { Children } from 'react';
import { Box } from '../Box/index.js';
import { useTheme } from '../hooks/useTheme.js';
import flattenChildren from 'react-keyed-flatten-children';
import { Divider } from '../Divider/Divider.js';

var horizontalAlignMap = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
};
var Stack = function (_a) {
    var flat = _a.flat, _b = _a.minWidth, flatMinWidth = _b === void 0 ? 0 : _b, _c = _a.start, start = _c === void 0 ? "0" : _c, _d = _a.end, end = _d === void 0 ? "0" : _d, _e = _a.gap, gap = _e === void 0 ? "0" : _e, _f = _a.align, align = _f === void 0 ? "left" : _f, _g = _a.dividers, dividers = _g === void 0 ? false : _g, children = _a.children, props = __rest(_a, ["flat", "minWidth", "start", "end", "gap", "align", "dividers", "children"]);
    var _h = useTheme(), applyTheme = _h.applyTheme, handleStyleProps = _h.handleStyleProps;
    var minWidth = (flatMinWidth
        ? applyTheme({ minWidth: flatMinWidth })
        : { minWidth: 0 }).minWidth;
    var forwardProps = handleStyleProps(props, {
        baseStyle: flat
            ? {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(".concat(minWidth, ", 1fr))"),
                gap: gap,
                mt: start,
                mb: end,
                width: "100%",
                minWidth: minWidth,
            }
            : {
                display: "flex",
                gap: gap,
                justifyContent: horizontalAlignMap[align],
                alignItems: align === "center" ? "center" : undefined,
                flexDirection: "column",
                mt: start,
                mb: end,
                width: "100%",
                minWidth: minWidth,
            },
    });
    var stackItemArray = flattenChildren(children);
    var stackItems = Children.map(stackItemArray, function (stackItem, index) {
        var shouldIncludeDivider = dividers && index !== stackItemArray.length - 1;
        return (jsxs(Fragment, { children: [stackItem, shouldIncludeDivider && (jsx(Divider, { orientation: flat ? "vertical" : "horizontal" }))] }));
    });
    return jsx(Box, __assign({}, forwardProps, { children: stackItems }));
};

export { Stack };
//# sourceMappingURL=Stack.js.map
